import React from 'react';
import '../../styles/EditWebsite.css';

const EditWebsite = () => {
  const buttons = [
    { name: 'Vehicle', path: '/set-vehicle' },
    { name: 'Offer', path: '/set-offer' },
    { name: 'Slider', path: '/set-slider' },
    { name: 'Dev Log', path: '/set-dev' },
    { name: 'Part', path: '/set-part' },
    { name: 'Career', path: '/set-career' },
  ];

  return (
    <div className="edit-website">
      <h1>Edit Website</h1>
      <div className="buttons-container">
        {buttons.map((button, index) => (
          <a key={index} href={button.path} className="website-button">
            {button.name}
          </a>
        ))}
      </div>
    </div>
  );
};

export default EditWebsite;